export default "__VITE_ASSET__Bek7XmFk__"